import React from "react";
import Label from "../Label/Label";

const Checkbox = ({
  name,
  id,
  checked = false,
  onChange,
  label = "",
  required = false,
  disabled = false,
  className = "",
  labelClassName = "",
  error = "",
  noWrapper = false,
  ...props
}) => {
  const checkboxId = id || name;

  const checkboxElement = (
    <input
      type="checkbox"
      name={name}
      id={checkboxId}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={`w-4 h-4 text-theme-primary border-border-primary rounded focus:ring-theme-primary focus:ring-2 focus:ring-offset-0 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${
        error ? "border-red-500" : ""
      } ${noWrapper ? className : ""}`}
      style={{
        accentColor: "var(--theme-primary)",
        borderColor: checked ? "var(--theme-primary)" : error ? "#ef4444" : "var(--border-primary)",
        backgroundColor: checked ? "var(--theme-primary)" : "transparent",
      }}
      {...props}
    />
  );

  // If noWrapper is true, return just the checkbox input (for inline use)
  if (noWrapper) {
    return checkboxElement;
  }

  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex items-center">
        {checkboxElement}
        {label && (
          <Label
            htmlFor={checkboxId}
            required={required}
            className={`ml-2 mb-0 cursor-pointer ${labelClassName} ${
              disabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {label}
          </Label>
        )}
      </div>
      {error && <span className="text-red-600 text-xs mt-1 ml-6">{error}</span>}
    </div>
  );
};

export default Checkbox;
